module.exports = __webpack_public_path__ + "img/597.6714b326.jpg";